module.exports = __webpack_public_path__ + "img/Public-Access-System.0892516d.png";